import React, { useState, useEffect } from "react";
import {
  getFirestore,
  collection,
  getDocs,
  updateDoc,
  doc,
  setDoc,
  deleteField,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// const db = firestore;
import ReactLoading from "react-loading";

const db = getFirestore();

const NewMenuTextDemo = ({
  setNewMenuType,
  newMenu,
  setNewMenu,
  menuList,
  setMenuList,
  menuListEnglish,
  setMenuListEnglish,
  textInformation,
  setTextInformation,
  menuFetchSelectors,
  setMenuFetchSelectors,
  menuFetchUrl,
  setMenuFetchUrl,
  menuFetchAvailable,
  setMenuFetchAvailable,
  menuFetchUrlEnglish,
  setMenuFetchUrlEnglish,
  config,
  setConfig,
  setMenuFetchUrlType,
  ignoreTerms,
  setIgnoreTerms,
  includeTerms,
  setIncludeTerms,
  lokasjonstype,
  // "Get suggested tags" button + results from menu.js (same state as there)
  suggestedTagsPanel,
}) => {
  const [category, setCategory] = useState("");
  const [text, setText] = useState("");
  const [allergenList, setAllergenList] = useState("");
  const [menuType, setMenuType] = useState(""); // wings, simple, inlineprice, codes, sumfirst
  const [visibleMenus, setVisibleMenus] = useState({});
  const [isEditable, setIsEditable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOvercategory, setSelectedOvercategory] = useState(null);

  // const client = new PlacesClient({
  //   apiKey: "AIzaSyBzqNdOb1GQUpeP2bFfsed64Yp_hEALAQ4", // or your API key string
  // });
  const apiKey = "AIzaSyDqzmqVbzF1erFBfSbzTWvF6TaSnv7HoI8";

  const toggleEditMode = () => {
    setIsEditable(!isEditable);
  };

  useEffect(() => {
    console.log("menuList changed:", menuList);
    const menuVisibility = {};
    Object.keys(menuList).forEach((element) => {
      menuVisibility[element] = false; // Start with all menus expanded
    });

    setVisibleMenus(menuVisibility);
  }, [menuList]);

  const toggleMenuVisibility = (element) => {
    setVisibleMenus((prevVisibleMenus) => ({
      ...prevVisibleMenus,
      [element]: !prevVisibleMenus[element],
    }));
  };

  const onDeleteItem = (index) => {
    let updatedMenuItems = [...menuList];
    updatedMenuItems.splice(index, 1);
    setMenuList(updatedMenuItems);
    // Optionally, you can also update the English menu list if needed
    // setMenuListEnglish(updatedMenuItems);
  };

  const linkToMenu = async (text) => {
    try {
      const response = await fetch(
        `https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/imageToMenu/${text}`,
      );
      const result = await response.json();
      console.log(`Meny ${result}"`); // Debugging line
      // return result.choices[0].message.content; // Adjust based on your API's response structure
    } catch (error) {
      console.error(`Error translating text "${text}":`, error);
      return text; // Fallback to the original text in case of an error
    }
  };

  const parseMenuText = () => {
    let updatedMenuItems = [...menuList];

    // Bygger opp en map av allergener fra allergenList-state
    const buildAllergenMap = (listStr) => {
      if (!listStr || !listStr.trim()) return {};
      const lines = listStr
        .split("\n")
        .map((l) => l.trim())
        .filter(Boolean);
      const map = {};
      lines.forEach((line) => {
        const parts = line.split(/\s+/);
        const code = parts[0];
        const name = parts.slice(1).join(" ");
        if (code && name) {
          map[code.toUpperCase()] = name;
        }
      });
      return map;
    };

    const allergenMap = buildAllergenMap(allergenList);

    // Oversetter f.eks. "1, 6A, 14" til ["Melk", "Hvete", "Sulfitt"]

    const capitalizeWord = (str) =>
      str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

    const translateAllergens = (codesStr) => {
      if (!codesStr || !codesStr.trim()) return "";

      // Fjern parenteser først
      const cleaned = codesStr.replace(/[()]/g, "").trim();

      return cleaned
        .split(/\s*,\s*/) // støtter "1,2", "1, 2", "1 , 2"
        .map((c) => c.trim().toUpperCase())
        .filter(Boolean)
        .map((c) => {
          const translated = allergenMap[c] || c;
          return capitalizeWord(translated);
        })
        .join(", ");
    };

    const lines = text
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);

    const newMenuItems = [];
    let i = 0;

    while (i < lines.length) {
      const name = capitalizeWords(lines[i] || "");
      const description = lines[i + 1] || "";

      let allergies = "";
      let price = null;
      let variants = null;

      // Wings, Simple og Codes
      if (
        menuType === "wings" ||
        menuType === "simple" ||
        menuType === "codes" ||
        menuType === "simply"
      ) {
        allergies =
          menuType === "simple" || menuType === "codes"
            ? lines[i + 2]
            : menuType === "simply"
              ? lines[i + 3]
              : "";

        const priceOrVariantLine =
          lines[i + (menuType === "wings" || menuType === "simply" ? 2 : 3)] ||
          "";

        if (priceOrVariantLine.includes("|")) {
          variants = parseVariants(priceOrVariantLine);
          price = null;
        } else {
          price = extractPrice(priceOrVariantLine);
          variants = null;
        }

        i += menuType === "wings" ? 3 : 4;
      }

      // Inline price
      else if (menuType === "inlineprice") {
        const descLineRaw = lines[i + 1] || "";
        const descLine = normalizeLine(descLineRaw);

        const priceMatch = descLine.match(/^(.*)\s(\d+)[-]?\s*$/);
        let parsedDescription = descLine;

        if (priceMatch) {
          parsedDescription = priceMatch[1].trim();
          price = parseInt(priceMatch[2]);
        } else {
          price = null;
        }

        allergies = "";
        variants = null;
        i += 2;

        newMenuItems.push({
          name,
          description: parsedDescription,
          allergies: translateAllergens(allergies),
          price,
          variants,
        });
        continue;
      }

      // Sum first
      else if (menuType === "sumfirst") {
        const priceLine = lines[i] || "";
        const nameLine = lines[i + 1] || "";
        const descLine = lines[i + 2] || "";

        price = extractPrice(priceLine);
        const name = capitalizeWords(nameLine);
        const description = descLine;

        allergies = "";
        variants = null;
        i += 3;

        newMenuItems.push({
          name,
          description,
          allergies: translateAllergens(allergies),
          price,
          variants,
        });
        continue;
      } else if (menuType === "sumfirstallergies") {
        const priceLine = lines[i] || "";
        const nameLine = lines[i + 1] || "";
        const descLine = lines[i + 2] || "";
        const allergies = lines[i + 3] || "";

        price = extractPrice(priceLine);
        const name = capitalizeWords(nameLine);
        const description = descLine;

        variants = null;
        i += 4;

        newMenuItems.push({
          name,
          description,
          allergies: translateAllergens(allergies),
          price,
          variants,
        });
        continue;
      } else if (menuType === "titlepricedescription") {
        const nameLine = lines[i] || "";
        const priceLine = lines[i + 1] || "";
        const descLine = lines[i + 2] || "";
        const allergies = "";

        price = extractPrice(priceLine);
        const name = capitalizeWords(nameLine);
        const description = descLine;

        variants = null;
        i += 3;

        newMenuItems.push({
          name,
          description,
          allergies: translateAllergens(allergies),
          price,
          variants,
        });
        continue;
      } else if (menuType === "titledescription") {
        const nameLine = lines[i] || "";
        const descLine = lines[i + 1] || "";
        const allergies = "";
        const priceLine = "";

        price = extractPrice(priceLine);
        const name = capitalizeWords(nameLine);
        const description = descLine;

        variants = null;
        i += 2;

        newMenuItems.push({
          name,
          description,
          allergies: translateAllergens(allergies),
          price,
          variants,
        });
        continue;
      }

      // Title, price, allergies
      else if (menuType === "titlepriceallergies") {
        const titleLine = lines[i] || "";
        const nextLine = lines[i + 1] || "";
        const thirdLine = lines[i + 2] || "";

        let name = capitalizeWords(titleLine);
        let desc = "";
        let price = null;
        let variants = null;
        let allergies = "";

        if (/\d/.test(titleLine)) {
          // INLINE
          const parts = titleLine.split(/(\d.*)$/);
          name = capitalizeWords(parts[0].trim());
          const pricePart = (parts[1] || "").trim();

          if (pricePart.includes("|") || pricePart.includes("/")) {
            variants = parseVariants(pricePart);
            price = null;
          } else {
            price = extractPrice(pricePart);
            variants = null;
          }

          allergies = nextLine;
          i += 2;
        } else {
          // MULTILINJE
          if (nextLine.includes("|") || nextLine.includes("/")) {
            variants = parseVariants(nextLine);
            price = null;
          } else {
            price = extractPrice(nextLine);
            variants = null;
          }

          allergies = thirdLine;
          i += 3;
        }

        newMenuItems.push({
          name,
          description: desc,
          allergies: translateAllergens(allergies),
          price,
          variants,
        });
        continue;
      }

      // Title, price, description, allergies
      else if (menuType === "titlepricedescriptionallergies") {
        const titleLine = lines[i] || "";
        const nextLine = lines[i + 1] || "";
        const thirdLine = lines[i + 2] || "";
        const forthLine = lines[i + 3] || "";

        let name = capitalizeWords(titleLine);
        let desc = "";
        let price = null;
        let variants = null;
        let allergies = "";

        if (/\d/.test(titleLine)) {
          // INLINE
          const parts = titleLine.split(/(\d.*)$/);
          name = capitalizeWords(parts[0].trim());
          const pricePart = (parts[1] || "").trim();

          if (pricePart.includes("|") || pricePart.includes("/")) {
            variants = parseVariants(pricePart);
            price = null;
          } else {
            price = extractPrice(pricePart);
            variants = null;
          }

          desc = nextLine;
          allergies = thirdLine;

          i += 3;
        } else {
          // MULTILINJE
          if (nextLine.includes("|") || nextLine.includes("/")) {
            variants = parseVariants(nextLine);
            price = null;
          } else {
            price = extractPrice(nextLine);
            variants = null;
          }

          desc = thirdLine;
          allergies = forthLine;
          i += 4;
        }

        newMenuItems.push({
          name,
          description: desc,
          allergies: translateAllergens(allergies),
          price,
          variants,
        });
        continue;
      }

      // Title, price
      else if (menuType === "titleprice") {
        const titleLine = lines[i] || "";
        const priceLine = lines[i + 1] || 0;

        const name = capitalizeWords(titleLine);
        const desc = "";
        price = extractPrice(priceLine);
        allergies = "";
        variants = null;

        i += 2;

        newMenuItems.push({
          name,
          description: desc,
          allergies: translateAllergens(allergies),
          price,
          variants,
        });
        continue;
      } else if (menuType === "titleallergiesprice") {
        const titleLine = lines[i] || "";
        const allergiesLine = lines[i + 1] || "";
        const priceLine = lines[i + 2] || 0;

        const name = capitalizeWords(titleLine);
        const desc = "";
        price = extractPrice(priceLine);
        allergies = allergiesLine;
        variants = null;

        i += 3;

        newMenuItems.push({
          name,
          description: desc,
          allergies: translateAllergens(allergies),
          price,
          variants,
        });
        continue;
      }

      // Price, title
      else if (menuType === "pricetitle") {
        const priceLine = lines[i] || 0;
        const titleLine = lines[i + 1] || "";

        const name = capitalizeWords(titleLine);
        const desc = "";
        price = extractPrice(priceLine);
        allergies = "";
        variants = null;

        i += 2;

        newMenuItems.push({
          name,
          description: desc,
          allergies: translateAllergens(allergies),
          price,
          variants,
        });
        continue;
      }

      // fallback
      newMenuItems.push({
        name,
        description,
        allergies: translateAllergens(allergies),
        price,
        variants,
      });
    }

    updatedMenuItems.push({
      category: capitalizeWords(category),
      menuItems: [],
      alergener: [],
      prices: [],
      descriptions: [],
      variants: {},
    });

    const lastMenu = updatedMenuItems[updatedMenuItems.length - 1];

    newMenuItems.forEach((item) => {
      const index = lastMenu.menuItems.length;

      lastMenu.menuItems.push(item.name);
      lastMenu.alergener.push(item.allergies || "");
      lastMenu.prices.push(typeof item.price === "number" ? item.price : null);
      lastMenu.descriptions.push(item.description);
      if (Array.isArray(item.variants) && item.variants.length > 0) {
        lastMenu.variants[String(index)] = item.variants;
      }
    });

    setMenuList(updatedMenuItems);
  };

  function parseVariants(line) {
    if (!line) return null;

    const clean = line
      .replace(/\s+/g, " ")
      .replace(/\s*(\||\/)\s*/g, "|")
      .trim();

    const variants = [];
    const parts = clean.split("|");

    for (let part of parts) {
      const text = part.trim();
      if (!text) continue;

      // If the part starts with a digit, treat whole thing as the price
      if (/^\d/.test(text)) {
        const price = parseFloat(text.replace(",", "."));
        if (!Number.isNaN(price)) variants.push({ name: "", price });
        continue;
      }

      // Otherwise expect "Name Number"
      const m = text.match(/^(.+?)\s+(\d+(?:[.,]\d+)?)/);
      if (m) {
        const name = m[1].trim().replace(/[\s\-|:/]+$/, "");
        const price = parseFloat(m[2].replace(",", "."));
        variants.push({ name, price });
      }
    }

    return variants.length ? variants : null;
  }

  function normalizeLine(line) {
    return line
      .replace(/[\u2013\u2014\u2212]/g, "-") // alle rare minuser til vanlig -
      .replace(/[–—−]/g, "-") // ekstra fallback
      .replace(/[ ]/g, " ") // non-breaking space til vanlig space
      .replace(/[,]/g, "") // fjern komma helt
      .trim();
  }

  function extractPrice(line) {
    const match = line.match(/(\d+)/);
    return match ? parseInt(match[1]) : null;
  }

  function capitalizeWords(str) {
    return str
      .toLowerCase()
      .split(/(\s|-|\/)/g) // behold mellomrom, bindestrek og skråstrek
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join("");
  }

  function updateSelector(key, value) {
    setConfig((prev) => ({ ...prev, [key]: value }));
  }

  async function getMenu23(url) {
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://wolt-scraper-609436138667.europe-north1.run.app/scrape",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ url }),
        },
      );

      if (!response.ok) {
        console.error(
          "Server responded with:",
          response.status,
          response.statusText,
        );
        return;
      }

      const data = await response.json();
      setMenuList(data.categories);
      setMenuFetchUrlType("wolt");
      console.log("Universal scrape result:", data);
      return data;
    } catch (err) {
      console.error("Request error:", err);
    }
    setIsLoading(false);
  }

  async function getImagesFromWebsite(url) {
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/scrape-images",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ url }),
        },
      );

      const data = await response.json();

      console.log("Image scrape data:", data);

      const rawResults = await Promise.all(
        data.images.map((imageUrl) => getMenuFromImage({ imageUrl: imageUrl })),
      );

      // ✅ CLEANUP STEP
      const cleanedMenuData = rawResults
        .filter(Boolean) // remove null / undefined
        .flat(); // flatten arrays into 1 level

      console.log("✅ Cleaned menu:", cleanedMenuData);
      setMenuList(cleanedMenuData);
      setMenuFetchUrlType("images");
    } catch (err) {
      console.error("Request error:", err);
    }
    setIsLoading(false);
  }

  async function getMenuFromURL(url) {
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/scrape-menutext-from-web",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ url }),
        },
      );

      const data = await response.json();

      console.log("Data: ", data);
      console.log("Menu Data: ", data);
      if (data.menuData) {
        setMenuList(data.menuData);
      } else {
        setMenuList([]);
      }
      setMenuFetchUrlType("URL");
    } catch (err) {
      console.error("Request error:", err);
    }
    setIsLoading(false);
  }

  async function getMenuFromSlowURL(url) {
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://menu-text-scraper-609436138667.europe-north1.run.app/scrape-menutext-from-web-slow",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ url }),
        },
      );

      const data = await response.json();

      console.log("Data: ", data);
      console.log("Menu Data: ", data);
      if (data.menuData) {
        setMenuList(data.menuData);
      } else {
        setMenuList([]);
      }
      setMenuFetchUrlType("URL-Slow");
    } catch (err) {
      console.error("Request error:", err);
    }
    setIsLoading(false);
  }
const GENERIC_LINK_PHRASES = [
  "view menu", "view menus", "view the menu", "view the menus",
  "see menu", "see menus", "download menu", "download", "download our menus", "download our menu",
  "click to view menu", "click to view menus", "click to see menu", "click to see menus",
  "click here for menu", "click here for menus", "click here to view menu", "click here to view menus",
  "click here", "se meny", "vis meny", "vis menyer", "åpne meny",
  "meny", "menu", "menus", "pdf", "view", "open",
  "her", "se her", "trykk her", "downloadable menu", "downloadable menus", "view our menu", "view our menus", "see our menu", "see our menus",
];
 
function isGenericLinkText(text) {
  if (!text) return true;
  const normalized = text.trim().toLowerCase().replace(/[.!?]+$/, "");
  if (normalized.length < 3) return true;
  const stripped = normalized.replace(/[^a-zæøå ]/g, "").trim();
  return GENERIC_LINK_PHRASES.some(
    (phrase) => normalized === phrase || stripped === phrase
  );
}
 
function filenameToLabel(pdfUrl) {
  try {
    const filename = decodeURIComponent(pdfUrl.split("/").pop().split("?")[0]).replace(/\.pdf$/i, "");
    return filename.replace(/[_-]+/g, " ").trim();
  } catch {
    return null;
  }
}
 
function isUsableLabel(c) {
  return c && c.trim().length > 1 && c.trim().length < 60;
}
 
// Build a frequency map of every value seen for a given field, counted
// per DISTINCT PDF rather than per image. A tall menu PDF gets sliced into
// several images that all share the same nearbyHeading/imgAlt — that's
// expected and correct, not a sign of a sitewide tagline. What actually
// signals "this is a page-wide element, not a real section title" is the
// same string showing up across multiple *different* PDFs.
function buildFrequencyMap(images, field) {
  const seenPerPdf = new Map(); // pdfUrl -> value, so each PDF counts once
 
  for (const img of images) {
    const val = img[field]?.trim().toLowerCase();
    if (!val) continue;
    if (!seenPerPdf.has(img.pdfUrl)) {
      seenPerPdf.set(img.pdfUrl, val);
    }
  }
 
  const counts = new Map();
  for (const val of seenPerPdf.values()) {
    counts.set(val, (counts.get(val) || 0) + 1);
  }
  return { counts, distinctPdfCount: seenPerPdf.size };
}
 
function isTooCommon(value, freqMapResult) {
  if (!value) return false;
  const { counts, distinctPdfCount } = freqMapResult;
  const key = value.trim().toLowerCase();
  const count = counts.get(key) || 0;
  // If this exact string is attached to 3+ DIFFERENT PDFs, or more than
  // ~50% of all distinct PDFs, it's almost certainly a sitewide element
  // (tagline, nav label, footer text) rather than a real per-PDF title.
  // A single PDF repeating its own heading across slices never triggers
  // this, since it only ever contributes once to the count.
  if (distinctPdfCount <= 1) return false;
  return count >= 3 || count / distinctPdfCount > 0.5;
}
 
// Priority order:
// 1) Nearby heading on the page — but only if it isn't suspiciously common
// 2) Image alt text — same frequency check applies
// 3) Link text, but only if it's not generic ("view menu" etc.)
// 4) The PDF's own first-page text
// 5) Link text again, even if generic — better than nothing
// 6) Filename, as an absolute last resort
function pickOvercategoryLabel(image, allImages) {
  const headingFreq = buildFrequencyMap(allImages, "nearbyHeading");
  const altFreq = buildFrequencyMap(allImages, "imgAlt");
 
  const candidates = [
    !isTooCommon(image.nearbyHeading, headingFreq) ? image.nearbyHeading : null,
    !isTooCommon(image.imgAlt, altFreq) ? image.imgAlt : null,
    !isGenericLinkText(image.linkText) ? image.linkText : null,
    image.pdfTitleGuess,
    isGenericLinkText(image.linkText) ? image.linkText : null,
    filenameToLabel(image.pdfUrl),
  ];
 
  return candidates.find(isUsableLabel) || null;
}
 
// ──────────────────────────────────────────────────────────────
// PDF fetching + menu extraction
// ──────────────────────────────────────────────────────────────
 
async function getPdfsFromWebsite(url) {
  setIsLoading(true);
  console.log("Fetching PDFs from:", url);
 
  try {
    // ✅ Convert comma-separated strings → clean arrays
    const ignoreTermsArray = ignoreTerms
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);
 
    const includeTermsArray = includeTerms
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);
 
    const response = await fetch(
      "https://pdf-scraper-2-609436138667.europe-north1.run.app/scrape-pdf",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          url: url,
          ignoreTerms: ignoreTermsArray,
          onlyTheseTerms: includeTermsArray,
        }),
      },
    );
 
    const data = await response.json();
    console.log("PDF scrape data:", data);
 
    if (!data.success || !Array.isArray(data.images)) {
      throw new Error(data.error || "PDF scrape failed");
    }
 
    // How many distinct source PDFs are we dealing with?
    const distinctPdfUrls = new Set(data.images.map((img) => img.pdfUrl));
    const multiplePdfs = distinctPdfUrls.size > 1;
 
    // Promise.all preserves order, so rawResults[i] <-> data.images[i]
    const rawResults = await Promise.all(
      data.images.map((image) =>
        getMenuFromImage({
          imageUrl: image.imageUrl,
        }),
      ),
    );
 
    const taggedResults = rawResults.map((menuData, i) => {
      if (!menuData) return null;
 
      if (!multiplePdfs) return menuData; // unchanged shape, no overcategory key
 
      const overcategory = pickOvercategoryLabel(data.images[i], data.images);
      return menuData.map((section) => ({
        ...section,
        overcategory,
      }));
    });
 
    const cleanedMenuData = taggedResults.filter(Boolean).flat();
 
    setMenuList(cleanedMenuData);
    setMenuFetchUrlType("PDFs");
  } catch (err) {
    console.error("Request error:", err);
  }
 
  setIsLoading(false);
}
 
async function getMenuFromImage({ imageUrl, base64 }) {
  try {
    const body = imageUrl !== null ? { imageUrl } : { imageBase64: base64 };
 
    const response = await fetch(
      "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/getMenuFromImage",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      },
    );
 
    const data = await response.json();
 
    if (!data?.menuData?.length) return null;
    return data.menuData;
  } catch (err) {
    console.error("Request error:", err);
    return null;
  }
}

  async function fetchMenuFromServer() {
    const fullConfig = {
      url: menuFetchUrl,
      selectors: {
        category_container: ".menu-section",
        category_name: "h2",
        product_item: ".menu-item",
        title: ".title",
        description: ".desc",
        price: ".price",
      },
    };

    console.log("Using config:", fullConfig);

    const language = "no"; // or "no", "sv", "fi", etc. — dynamic per country

    const response = await fetch(
      "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/getMenu",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ config: fullConfig, language }),
      },
    );

    const data = await response.json();
    setMenuList(data.menuData);
    setMenuFetchUrlType("selectors");
    console.log("Scraped menu:", data);
  }

  const fetchMenuFromAPITest = async (url) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/getMenuFromAPI",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ apiUrl: url }),
        },
      );

      const data = await response.json();

      let newMenuItemsList = [];

      console.log("Data: ", data);
      data.menuCategories.forEach((category) => {
        let menuItemList = {};
        if (category.menuItems.length === 0) return;
        let categoryy = category.categoryName;
        let menuItems = [];
        let alergener = [];
        let descriptions = [];
        let prices = [];
        let variants = {};
        console.log("Category: ", category.categoryName);
        category.menuItems.forEach((item) => {
          menuItems.push(item.name);
          descriptions.push(item.description);
          prices.push(item.price);
          console.log(" Item: ", item.name);
          console.log(" Item: ", item.description);
          console.log(" Item: ", item.price);
          let allergens = [];
          item.allergens !== null
            ? item.allergens.forEach((allergy) => {
                allergens.push(allergy.name);
              })
            : (allergens = [""]);
          console.log(" Item Allergens: ", allergens.join(", "));
          alergener.push(allergens.join(", "));
        });
        menuItemList = {
          category: categoryy,
          menuItems: menuItems,
          descriptions: descriptions,
          prices: prices,
          alergener: alergener,
          variants: variants,
        };
        newMenuItemsList.push(menuItemList);
      });
      setMenuList(newMenuItemsList);

      // setMenuFetchUrlType("URL");
    } catch (err) {
      console.error("Request error:", err);
    }
    setIsLoading(false);
  };

  const mapping = {
    categoriesPath: "$" + config.category_container + "[*]",
    categoryNamePath: "$" + config.category_name,
    itemsPath: "$" + config.product_item + "[*]",
    item: {
      namePath: "$" + config.title,
      descriptionPath: "$" + config.description,
      pricePath: "$" + config.price,
      allergensPath: "$" + config.allergens,
    },
  };

  const menuConfig = {
    apiUrl: menuFetchUrl,
    mapping: mapping,
  };

  const idAPI = menuFetchUrlEnglish;

  // {
  //     categoriesPath: "$.menuCategories[*]",
  //     categoryNamePath: "$.categoryName",
  //     itemsPath: "$.menuItems[*]",
  //     item: {
  //       namePath: "$.name",
  //       descriptionPath: "$.description",
  //       pricePath: "$.price",
  //       allergensPath: "$.allergens[*].name",
  //     },

  const fetchMenuFromAPI = async (menuConfig) => {
    if (!menuConfig?.apiUrl || !menuConfig?.mapping) {
      throw new Error("Missing menuConfig.apiUrl or menuConfig.mapping");
    }
    if (idAPI !== "") {
      try {
        // 1️⃣ Fetch list of IDs
        const response = await fetch(
          "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/getMenuApiTest",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ apiUrl: idAPI }),
          },
        );

        const ids = await response.json(); // array of objects
        console.log("IDs:", ids);

        // 2️⃣ Fetch all menus in parallel
        const menus = await Promise.all(
          ids.map(async (idObj) => {
            const id = idObj[ignoreTerms];
            if (!id) return [];

            const url = menuConfig.apiUrl + id;
            console.log("Fetching URL:", url);

            const res = await fetch(
              "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/getMenuFromAPI",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  apiUrl: url,
                  mapping: menuConfig.mapping,
                }),
              },
            );

            const menu = await res.json();
            return menu; // array of categories
          }),
        );

        // 3️⃣ Flatten all category arrays
        const mergedMenu = menus.flat();

        console.log("FINAL MENU:", mergedMenu);
        setMenuList(mergedMenu);
        setMenuFetchUrlType("multipleApi");
      } catch (err) {
        console.error("Request error:", err);
      }

      return;
    }

    setIsLoading(true);
    console.log("Fetching menu from API with config:", menuConfig);

    try {
      if (!menuConfig?.apiUrl || !menuConfig?.mapping) {
        throw new Error("Missing menuConfig.apiUrl or menuConfig.mapping");
      }

      const response = await fetch(
        "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/getMenuFromAPI",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            apiUrl: menuConfig.apiUrl,
            mapping: menuConfig.mapping,
          }),
        },
      );

      const formattedMenu = await response.json();
      setMenuList(formattedMenu);
      setMenuFetchUrlType("api");
    } catch (err) {
      console.error("Request error:", err);
    }

    setIsLoading(false);
  };

  const fetchGoogle = async () => {
    const res = await fetch(
      `https://places.googleapis.com/v1/places/ChIJHQJnKsbzT0YRNdVL36jxuno`,
      {
        headers: {
          "X-Goog-Api-Key": apiKey,
          "X-Goog-FieldMask": "businessMenus",
        },
      },
    );

    console.log(res.json());
  };
  //   try {
  //     const response = await client.placeDetails({
  //       place_id: "ChIJHQJnKsbzT0YRNdVL36jxuno",
  //       // Optional: fields you want
  //       // fields: [
  //       //   "name",
  //       //   "formatted_address",
  //       //   "geometry",
  //       //   "formatted_phone_number",
  //       //   "website",
  //       //   "rating",
  //       //   "user_ratings_total",
  //       //   "opening_hours",
  //       // ],
  //     });

  //     console.log("Place Details:", response.data);
  //     return response.data;
  //   } catch (error) {
  //     console.error("Error fetching place details:", error);
  //     throw error;
  //   }
  // };

  const getActivitiesFromURL = async (url) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/scrape-activities-from-web",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ url }),
        },
      );

      const data = await response.json();

      console.log("Data: ", data);
      console.log("Menu Data: ", data);
      if (data.activities) {
        setMenuList(data.activities);
      } else {
        setMenuList([]);
      }
      setMenuFetchUrlType("URL");
    } catch (err) {
      console.error("Request error:", err);
    }
    setIsLoading(false);
  };

  const getActivitiesFromURLSlow = async (url) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://activity-text-scraper-609436138667.europe-north1.run.app/scrape-activitytext-from-web-slow",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ url }),
        },
      );

      const data = await response.json();

      console.log("Data: ", data);
      console.log("Menu Data: ", data);
      if (data.activities) {
        setMenuList(data.activities);
      } else {
        setMenuList([]);
      }
      setMenuFetchUrlType("URL");
    } catch (err) {
      console.error("Request error:", err);
    }
    setIsLoading(false);
  };

  return (
    <>
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "10px",
          }}>
          MenuFetchAvailable?
          <input
            type='checkbox'
            style={{ width: "20px", height: "20px", marginRight: "10px" }}
            checked={menuFetchAvailable}
            onChange={(e) => setMenuFetchAvailable(e.target.checked)}
          />
        </div>

        {menuFetchAvailable && (
          <>
            {/* Lokal: */}
            Url:<br></br>
            <input
              type='text'
              value={menuFetchUrl}
              onChange={(e) => setMenuFetchUrl(e.target.value)}
              placeholder='Menu URL to fetch'
              style={{ width: "300px", marginBottom: "10px" }}
            />
            <br></br>
            <br></br>
            {/* Engelsk:
            <input
              type='text'
              value={menuFetchUrlEnglish}
              onChange={(e) => setMenuFetchUrlEnglish(e.target.value)}
              placeholder='English Menu URL to fetch'
              style={{ width: "300px", marginBottom: "10px" }}
            /> */}
            {/* Quick selector inputs */}
            {/* {Object.keys(config).map((key) => (
              <input
                key={key}
                type='text'
                value={config[key]}
                onChange={(e) => updateSelector(key, e.target.value)}
                placeholder={key}
                style={{
                  width: "300px",
                  display: "block",
                  marginBottom: "5px",
                }}
              />
            ))} */}
            Ignore terms:
            <input
              type='text'
              value={ignoreTerms}
              onChange={(e) => setIgnoreTerms(e.target.value)}
              placeholder='Ignore Terms (comma separated)'
              style={{ width: "300px", display: "block", marginBottom: "5px" }}
            />
            <br></br>
            Include terms:
            <input
              type='text'
              value={includeTerms}
              onChange={(e) => setIncludeTerms(e.target.value)}
              placeholder='Include Terms (comma separated)'
              style={{ width: "300px", display: "block", marginBottom: "5px" }}
            />
            {isLoading && (
              <>
                Loading... This can take some time. You can freely go back and
                do other things while waiting.
                <br></br>
                <ReactLoading
                  type={"spin"}
                  color={"#357EDD"}
                  height={60}
                  width={30}
                />
              </>
            )}
            <br></br>
            {/* <button onClick={() => cleanupBusinessEventsArray()}>
              Danger!!!
            </button> */}
            {/* <button onClick={() => fetchMenuFromAPI(menuConfig)}>
              Fetch Menu From Selectors
            </button> */}
            {lokasjonstype === "restaurant" ? (
              <>
                <button onClick={() => getMenuFromURL(menuFetchUrl)}>
                  Fetch Menu From Link via Text
                </button>
                <button onClick={() => getMenuFromSlowURL(menuFetchUrl)}>
                  Fetch Menu From Link via Text from Slowloaded website
                </button>
                <button onClick={() => getMenu23(menuFetchUrl)}>
                  Fetch Wolt from Link
                </button>
                <button onClick={() => getImagesFromWebsite(menuFetchUrl)}>
                  Fetch Menu From Image
                </button>
                <button onClick={() => getPdfsFromWebsite(menuFetchUrl)}>
                  Fetch Menu From PDFs
                </button>
                <button onClick={() => fetchGoogle()}>Google?</button>
              </>
            ) : (
              <>
                <button onClick={() => getActivitiesFromURL(menuFetchUrl)}>
                  Fetch Activities from Text
                </button>
                <button onClick={() => getActivitiesFromURLSlow(menuFetchUrl)}>
                  Fetch Activities from Text (Slow)
                </button>
              </>
            )}
          </>
        )}
      </div>
      <button
        onClick={() => {
          setNewMenuType("");
          setNewMenu(false);
        }}>
        Go back
      </button>
      {/* <p>Velg type meny</p>
      <select
        onChange={(e) => {
          setMenuType(e.currentTarget.value);
        }}>
        <option value=''>Velg type meny</option>
        <option value='wings'>Wings; Tittel/Beskrivelse/Pris</option>
        <option value='simple'>
          Simple; Tittel/Beskrivelse/Allergener/Pris
        </option>
        <option value='simply'>
          Simply; Tittel/Beskrivelse/Pris/Allergener
        </option>
        <option value='titledescription'>Title/Description</option>
        <option value='titleallergiesprice'>TitleAllergiesPrice</option>
        <option value='titlepriceallergies'>TitlePriceAllergies</option>
        <option value='titlepricedescriptionallergies'>
          TitlePriceDescriptionAllergies
        </option>
        <option value='titleprice'>TitlePrice</option>
        <option value='inlineprice'>Inline Price</option>
        <option value='pricetitle'>PriceTitle</option>
        <option value='codes'>Codes</option>
        <option value='sumfirst'>Pris/Tittel/Beskrivelse</option>
        <option value='sumfirstallergies'>
          Pris/Tittel/Beskrivelse/Allergener
        </option>
        <option value='titlepricedescription'>Tittel/Pris/Beskrivelse</option>
      </select>
      <br></br>
      <input
        onChange={(x) => setCategory(x.currentTarget.value)}
        placeholder='Kategori'
      />
      <br></br>
      <textarea
        onChange={(x) => setText(x.currentTarget.value)}
        placeholder={
          menuType === "wings"
            ? "Navn\nBeskrivelse\nPris eller varianter (f.eks. Variant1 50 | Variant2 60)\nEksempel: Kyllingvinger\nKyllingvinger med BBQ-saus\nVariant1 50 | Variant2 60\n"
            : menuType === "simple"
            ? "Navn\nBeskrivelse\nAllergener\nPris eller varianter (f.eks. Variant1 50 | Variant2 60)\nEksempel: Kyllingvinger\nKyllingvinger med BBQ-saus\nGluten, Melk\nVariant1 50 | Variant2 60\n"
            : menuType === "inlineprice"
            ? "Navn\nBeskrivelse med pris på slutten\nAllergener\nEksempel: Kyllingvinger\nKyllingvinger med BBQ-saus 50,-\nGluten, Melk\n"
            : menuType === "codes"
            ? "Navn\nBeskrivelse\nAllergener i tallformat\nPris eller varianter (f.eks. Variant1 50 | Variant2 60)\nEksempel: Kyllingvinger\nKyllingvinger med BBQ-saus\n1,6a,7\nVariant1 50 | Variant2 60\n"
            : menuType === "sumfirst"
            ? "Pris først, så navn, så beskrivelse\nEksempel: 50,-\nKyllingvinger\nKyllingvinger med BBQ-saus\n"
            : "VELG MENYTYPE FØRST"
        }
      />
      <br></br>
      <textarea
        onChange={(x) => setAllergenList(x.currentTarget.value)}
        placeholder={"Allergenliste (valgfri)"}
      />
      <br></br>
      <button onClick={() => parseMenuText()}>Legg til i meny</button>
      <button onClick={() => linkToMenu(category)}>Picture To Menu</button> */}
      {suggestedTagsPanel && <div style={{ margin: "10px 0" }}>{suggestedTagsPanel}</div>}
      {menuList.length > 0 ? (() => {
  // Distinct overcategories present in this menu (ignoring null/empty)
  const overcategories = [
    ...new Set(
      menuList
        .map((c) => c.overcategory)
        .filter((oc) => oc && oc.trim().length > 0)
    ),
  ];

  const hasMultipleOvercategories = overcategories.length > 1;

  // Which categories should actually render right now
  const visibleCategoryList = hasMultipleOvercategories
    ? selectedOvercategory
      ? menuList.filter((c) => c.overcategory === selectedOvercategory)
      : [] // nothing selected yet — force the picker
    : menuList; // single/no overcategory — behave exactly as before

  return (
    <>
      {hasMultipleOvercategories && (
        <div className='overcategoryDropdown'>
          {overcategories.map((oc) => (
            <button
              key={oc}
              className={
                selectedOvercategory === oc
                  ? 'overcategoryButtonActive'
                  : 'overcategoryButton'
              }
              onClick={() =>
                setSelectedOvercategory(selectedOvercategory === oc ? null : oc)
              }>
              {oc}
            </button>
          ))}
        </div>
      )}

      {visibleCategoryList.length > 0 &&
        visibleCategoryList.map((categoryData, index) => (
          <div key={index} className='menuListDropdown'>
            <h3 onClick={() => toggleMenuVisibility(categoryData.category)}>
              {categoryData.category} ⯆
            </h3>
            {visibleMenus[categoryData.category] && (
              <div className='menuListShown'>
                {categoryData.menuItems.map((itemName, itemIndex) => (
                  <div key={itemIndex} className='menuListShownItem'>
                    <div style={{ fontWeight: "bold" }}>
                      {isEditable ? (
                        <input
                          type='text'
                          defaultValue={itemName}
                          onChange={(e) => {
                            // handle name change
                            const newMenuItems = [...categoryData.menuItems];
                            newMenuItems[itemIndex] = e.target.value;
                            categoryData.menuItems = newMenuItems; // Update your state management accordingly
                          }}
                        />
                      ) : (
                        itemName.charAt(0).toUpperCase() + itemName.slice(1)
                      )}
                    </div>
                    <div style={{ color: "#5d3160" }}>
                      {isEditable ? (
                        <input
                          type='number'
                          defaultValue={categoryData.prices[itemIndex]}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value);
                            if (!isNaN(value)) {
                              const newPrices = [...categoryData.prices];
                              newPrices[itemIndex] = value;
                              categoryData.prices = newPrices;
                            }
                          }}
                        />
                      ) : categoryData.prices[itemIndex] !== null &&
                        categoryData.prices[itemIndex] !== undefined ? (
                        `${categoryData.prices[itemIndex]} NOK`
                      ) : Array.isArray(categoryData.variants?.[itemIndex]) &&
                        categoryData.variants?.[itemIndex]?.length > 0 ? (
                        categoryData.variants[itemIndex]
                          .map((v) => `${v.name} ${v.price} NOK`)
                          .join(" | ")
                      ) : (
                        "Ingen pris oppgitt"
                      )}
                    </div>
                    <div style={{ marginTop: "5px" }}>
                      {isEditable ? (
                        <textarea
                          defaultValue={categoryData.descriptions[itemIndex]}
                          onChange={(e) => {
                            const newDescriptions = [
                              ...categoryData.descriptions,
                            ];
                            newDescriptions[itemIndex] = e.target.value;
                            categoryData.descriptions = newDescriptions;
                          }}
                        />
                      ) : (
                        categoryData.descriptions[itemIndex]
                          .charAt(0)
                          .toUpperCase() +
                        categoryData.descriptions[itemIndex].slice(1)
                      )}
                    </div>
                    <div style={{ marginTop: "5px" }}>
                      Allergener:
                      {isEditable ? (
                        <input
                          type='text'
                          defaultValue={categoryData.alergener[itemIndex]}
                          onChange={(e) => {
                            const newDescriptions = [...categoryData.alergener];
                            newDescriptions[itemIndex] = e.target.value;
                            categoryData.alergener = newDescriptions;
                          }}
                        />
                      ) : (
                        categoryData.alergener[itemIndex]
                          .charAt(0)
                          .toUpperCase() +
                        categoryData.alergener[itemIndex].slice(1)
                      )}
                    </div>
                  </div>
                ))}
                <button onClick={toggleEditMode}>
                  {isEditable ? "Lagre" : "Rediger"}
                </button>
                <button
                  onClick={() => {
                    onDeleteItem(index);
                  }}>
                  Slett
                </button>
              </div>
            )}
          </div>
        ))}
    </>
  );
})() : (
  <></>
)}
    </>
  );
};

export default NewMenuTextDemo;
